export default __webpack_public_path__ + "static/media/rental-intro-excavator.9d51925a.jpg";